import { Users, Target, GitBranch, Zap } from "lucide-react";
import { useI18n } from "../i18n";
import { SectionHeading } from "./ui/card";
import { Reveal } from "./reveal";

/** Por que Vorto — quatro compromissos num grid 2×2 dividido por hairlines. */
export function WhyVorto() {
  const { t } = useI18n();
  const difs = [
    { icon: Users, titulo: t("dif.d1.t"), desc: t("dif.d1.d") },
    { icon: Target, titulo: t("dif.d2.t"), desc: t("dif.d2.d") },
    { icon: GitBranch, titulo: t("dif.d3.t"), desc: t("dif.d3.d") },
    { icon: Zap, titulo: t("dif.d4.t"), desc: t("dif.d4.d") },
  ];

  return (
    <section id="diferenciais" className="relative scroll-mt-24 bg-surface-2/50 py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-6">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.35fr] lg:gap-16">
          <Reveal>
            <SectionHeading
              index="04"
              label={t("dif.rotulo")}
              title={t("dif.titulo")}
              align="left"
              className="lg:sticky lg:top-28"
            />
          </Reveal>
          <div className="grid border-t border-l border-line sm:grid-cols-2">
            {difs.map((d, i) => (
              <Reveal key={d.titulo} delay={i * 0.06} className="h-full">
                <div className="group h-full border-r border-b border-line bg-surface p-6 transition-colors duration-300 hover:bg-background sm:p-7">
                  <span className="grid size-10 place-items-center rounded-lg bg-accent-soft text-accent transition-transform duration-300 group-hover:-translate-y-0.5">
                    <d.icon className="size-[18px]" strokeWidth={1.8} />
                  </span>
                  <h3 className="mt-4 font-display text-lg font-medium tracking-tight">
                    {d.titulo}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{d.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
